<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path data-follow-fill="currentColor" d="M889.6 952H135.4c-17.3 0-31.4-14.1-31.4-31.4 0-17.3 14.1-31.4 31.4-31.4h754.2c17.3 0 31.4 14.1 31.4 31.4S906.9 952 889.6 952zm0-125.7H135.4c-17.3 0-31.4-14.1-31.4-31.4V637.7c0-51.8 42.4-94.3 94.3-94.3h201.1c-6.3-37.7-25.1-73.9-51.9-105.3-36.1-40.9-55-92.7-55-146.1 0-59.7 23.6-116.3 67.6-158.7S460.7 70.4 521.9 72c113.1 4.7 209 102.1 210.5 215.3 1.6 56.6-20.4 111.6-58.1 154-26.7 28.3-42.4 62.9-48.7 102.1h201.1c51.8 0 94.3 42.4 94.3 94.3v157.1c0 17.4-14.1 31.5-31.4 31.5zm-722.8-62.9h691.4V637.7c0-17.3-14.1-31.4-31.4-31.4H591.1c-17.3 0-31.4-14.1-31.4-31.4 0-66 23.6-128.8 67.6-176 28.3-29.9 42.4-69.1 42.4-110-1.6-81.7-69.1-150.8-150.8-154-44-1.6-84.8 14.1-114.7 44-31.4 29.9-48.7 70.7-48.7 113.1 0 37.7 14.1 75.4 39.3 103.7 45.6 51.8 70.7 114.7 70.7 179.1 0 17.3-14.1 31.4-31.4 31.4H198.2c-17.3 0-31.4 14.1-31.4 31.4v125.8z" :fill="_fill" /></g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1.2em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
